import {useState} from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Tab, TabPanel, Tabs} from '@vio/atlas/src/components/designSystem/Tabs'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'

import {LinksList} from './LinksList'

import type {SeoLink} from 'seo/utils'

export interface LinksTab {
  id: string
  label: string
  links: SeoLink[] | undefined
}

interface Props {
  tabs: Array<LinksTab | undefined>
  dataId?: string
}

/**
 * Tabbed interlinking block for the brand footer. Absent tabs and tabs without
 * links are dropped, and nothing renders when none is left, so the footer never
 * shows an empty shell.
 */
export const LinksTabs = ({tabs, dataId}: Props) => {
  const {isMobile} = useDeviceLayout()
  const [selectedTab, setSelectedTab] = useState<string>()

  const tabsWithLinks = tabs.filter(tab => tab?.links?.length)

  if (!tabsWithLinks.length) return null

  const hasSelectedTab = tabsWithLinks.some(tab => tab.id === selectedTab)
  const activeTab = hasSelectedTab ? selectedTab : tabsWithLinks[0].id

  return (
    <Box data-id={dataId} paddingBottom="s800">
      <Tabs
        variant={isMobile ? 'fullWidth' : 'scrollable'}
        inverse
        activeTab={activeTab}
        onChange={setSelectedTab}
      >
        {tabsWithLinks.map(tab => (
          <Tab key={tab.id} value={tab.id} label={tab.label} />
        ))}
      </Tabs>

      {tabsWithLinks.map(tab => (
        <TabPanel key={tab.id} keepMounted value={tab.id} activeTab={activeTab}>
          <LinksList links={tab.links} />
        </TabPanel>
      ))}
    </Box>
  )
}
